// App-wide constants

// South African Provinces
export const PROVINCES = {
  'NORTH WEST': { name: 'North West', color: '#EF4444', code: 'NW' },
  'FREE STATE': { name: 'Free State', color: '#F59E0B', code: 'FS' },
  'GAUTENG': { name: 'Gauteng', color: '#10B981', code: 'GP' },
  'KWAZULU NATAL': { name: 'KwaZulu-Natal', color: '#3B82F6', code: 'KZN' },
  'MPUMALANGA': { name: 'Mpumalanga', color: '#8B5CF6', code: 'MP' },
  'LIMPOPO': { name: 'Limpopo', color: '#EC4899', code: 'LP' },
  'EASTERN CAPE': { name: 'Eastern Cape', color: '#F97316', code: 'EC' },
  'WESTERN CAPE': { name: 'Western Cape', color: '#06B6D4', code: 'WC' },
  'NORTHERN CAPE': { name: 'Northern Cape', color: '#84CC16', code: 'NC' },
};

// Fast food brands to search for
export const FAST_FOOD_BRANDS = [
  { name: 'KFC', keyword: 'KFC', color: '#E4002B', logo: '🍗' },
  { name: 'McDonald\'s', keyword: 'McDonalds', color: '#FFC72C', logo: '🍔' },
  { name: 'Steers', keyword: 'Steers', color: '#E31837', logo: '🔥' },
  { name: 'Nando\'s', keyword: 'Nandos', color: '#000000', logo: ' peri' },
  { name: 'Burger King', keyword: 'Burger King', color: '#D62300', logo: '👑' },
  { name: 'Wimpy', keyword: 'Wimpy', color: '#003366', logo: '🥪' },
  { name: 'Chicken Licken', keyword: 'Chicken Licken', color: '#FF6600', logo: '🍗' },
  { name: 'Debonairs', keyword: 'Debonairs Pizza', color: '#00A651', logo: '🍕' },
  { name: 'Roman\'s Pizza', keyword: 'Romans Pizza', color: '#ED1C24', logo: '🍕' },
  { name: 'Fishaways', keyword: 'Fishaways', color: '#0066B3', logo: '🐟' },
  { name: 'Spur', keyword: 'Spur Steak Ranch', color: '#8B0000', logo: '🥩' },
  { name: 'Ocean Basket', keyword: 'Ocean Basket', color: '#0077BE', logo: '🦐' },
  { name: 'Pizza Hut', keyword: 'Pizza Hut', color: '#E31837', logo: '🍕' },
  { name: 'Domino\'s', keyword: 'Dominos Pizza', color: '#006491', logo: '🍕' },
];

// Proximity radius options (in meters)
export const PROXIMITY_RADII = [
  { value: 500, label: '500m', description: 'Walking distance' },
  { value: 1000, label: '1km', description: 'Short drive' },
  { value: 2000, label: '2km', description: 'Medium drive' },
  { value: 5000, label: '5km', description: 'Extended area' },
  { value: 10000, label: '10km', description: 'Wide area' },
  { value: 20000, label: '20km', description: 'Regional' },
];

// Map configuration
export const MAP_CONFIG = {
  defaultZoom: 12,
  minZoom: 8,
  maxZoom: 18,
  defaultCenter: [-31.5889, 28.7891], // Mthatha, Eastern Cape
  style: 'mapbox://styles/mapbox/streets-v12',
};

// Average walking speed: 5 km/h = 83.3 m/min
// Average driving speed in urban area: 40 km/h = 666.7 m/min
export const TRAVEL_SPEEDS = {
  walking: 83.3, // meters per minute
  driving: 666.7, // meters per minute
};

// Status colors
export const STATUS_COLORS = {
  'Installed': 'success',
  'Cages': 'warning',
  'Pending': 'warning',
  'Active': 'success',
  'Inactive': 'error',
};

// Currency formatting
export const CURRENCY = {
  code: 'ZAR',
  symbol: 'R',
  locale: 'en-ZA',
};
